import React from 'react';
import axios from 'axios';
import moment from 'moment';
import Table from '../../components/Table';
import FontAwesome from 'react-fontawesome';
import { Button, Modal, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import './style.css';
import { Pie } from "react-chartjs-2";
import 'react-dates/lib/css/_datepicker.css';
import ExcelExport from '../../components/ExcelExport';

class Questions extends React.Component {
  render() {
    return (
      <div id="question-page">
        <div>
          <h3>Otázky</h3>
        </div>
        <QuestionSuccessRate {...this.props} />
        <SuccessRateByTag {...this.props} />
      </div>
    );
  }
}

class QuestionSuccessRate extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('cs');

    const columns = [
      {
        Header: 'Číslo otázky',
        accessor: 'questionInfo.name',
      },
      {
        Header: 'Jméno',
        accessor: 'questionInfo.text',
      },
      {
        Header: 'Obtížnost',
        accessor: 'questionInfo.difficulty',
      },
      {
        Header: 'Zodpovězeno',
        accessor: 'totalAnswers',
      },
      {
        Header: 'Správně',
        accessor: 'correctAnswers',
      },
      {
        Header: 'Špatně',
        accessor: 'wrongAnswers',
      },
      {
        Header: 'Úspěšnost',
        accessor: 'successRate',
      },
      {
        Header: 'Tagy',
        accessor: 'questionInfo.tags',
      },
      {
        Header: 'Založena',
        accessor: 'questionInfo.createdAt',
      },
      {
        Header: '',
        style: { padding: '0px' },
        filterable: false,
        Cell: row => (
          <div className="row-menu">
            <OverlayTrigger trigger="click" rootClose placement="left" overlay={(<AnswersGraph row={row.original} />)}>
              <FontAwesome name="pie-chart" className="cursor-p" />
            </OverlayTrigger>
          </div>
        )
      }
    ];

    const tableOptions = {
      showPagination: true,
      showPageSizeOptions: true,
      showPageJump: true,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      freezeWhenExpanded: false,
      filterable: true,
      sortable: true,
      resizable: true,
      defaultPageSize: 10,
    };

    this.state = {
      questions: [],
      loaded: false,
      columns: columns,
      tableOptions: tableOptions,
    };

    this.loadTableData = this.loadTableData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.loadTableData();
      this.setState({
        loaded: true,
      });
    }
  }

  loadTableData() {
    var loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.post(this.props.api.stats.questionAnswers, {
      cache: true,
    }, config)
      .then((result) => {
        if (!this._calledComponentWillUnmount) {
          result.data.forEach(function (question) {
            if (question.questionInfo && question.questionInfo.tagIds) {
              let tags = "";
              for (let i = 0; i < question.questionInfo.tagIds.length; i++) {
                if (i < question.questionInfo.tagIds.length - 1) {
                  tags += question.questionInfo.tagIds[i].name+", ";
                }
                else {
                  tags += question.questionInfo.tagIds[i].name;
                }
              }
              question.questionInfo.tags = tags;
              question.questionInfo.tagIds = question.questionInfo.tagIds.map((tag) => {
                return {
                  id: tag._id,
                  name: tag.name
                }
              });
            }
            return question;
          });
          this.setState({
            questions: result.data,
            tableOptions: {
              ...this.state.tableOptions,
              loading: false
            }
          })
        }
      }).catch(function (error) {
      console.error('Error axios:', error);
    });
  }

  render() {
    const { columns, questions, tableOptions } = this.state;
    const excelData = {
      fileName: 'Úspěšnost otázek',
      sheets: [
        {
          name: 'Úspěšnost otázek',
          columns: [
            {
              Header: 'Číslo otázky',
              accessor: 'questionInfo.name',
            },
            {
              Header: 'Jméno',
              accessor: 'questionInfo.text',
            },
            {
              Header: 'Obtížnost',
              accessor: 'questionInfo.difficulty',
            },
            {
              Header: 'Zodpovězeno',
              accessor: 'totalAnswers',
            },
            {
              Header: 'Správně',
              accessor: 'correctAnswers',
            },
            {
              Header: 'Špatně',
              accessor: 'wrongAnswers',
            },
            {
              Header: 'Úspěšnost',
              accessor: 'successRate',
            },
            {
              Header: 'Tagy',
              accessor: 'questionInfo.tags',
            },
            {
              Header: 'Založena',
              accessor: 'questionInfo.createdAt',
            },
          ],
          data: [...questions],
        }
      ],
    };

    const excelElement = (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-export-questions">Export</Tooltip>}>
        <FontAwesome name="file-excel-o" size="2x" className="cursor-p" />
      </OverlayTrigger>
    );

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Úspěšnost otázek</h2>
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <div className="export">
            <ExcelExport element={excelElement} data={excelData}/>
          </div>
          <Table
            columns={columns}
            data={questions}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
        </div>
      </div>
    );
  }
}

class SuccessRateByTag extends React.Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        Header: 'Tag',
        accessor: 'name',
      },
      {
        Header: "Celkem odpovědí",
        accessor: 'totalAnswers'
      },
      {
        Header: "Správných odpovědí",
        accessor: 'correctAnswers'
      },{
        Header: "Špatných odpovědí",
        accessor: 'wrongAnswers'
      },
      {
        Header: 'Úspěšnost',
        accessor: 'ratio',
      },
      {
        Header: 'Možnosti',
        style: { padding: '0px' },
        filterable: false,
        Cell: row => (
          <div className="row-menu">
            <OverlayTrigger trigger="click" rootClose placement="left" overlay={(<GraphForTag row={row.original} />)}>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tag_graph">Graf úspěšnosti tagu</Tooltip>}>
                <FontAwesome name="pie-chart" className="cursor-p" />
              </OverlayTrigger>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tag_list">Seznam otázek s tímto tagem</Tooltip>}>
              <FontAwesome name="table" className="cursor-p" onClick={() => this.showTagTable(row.original)} />
            </OverlayTrigger>
          </div>
        )
      }
      ];

    const tableOptions = {
      showPagination: true,
      showPageSizeOptions: true,
      showPageJump: true,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      freezeWhenExpanded: false,
      filterable: true,
      sortable: true,
      resizable: true,
      defaultPageSize: 10,
    };

    const tagTableColumns = [
      {
      Header: 'Číslo otázky',
      accessor: 'name',
      },
      {
        Header: 'Znění otázky',
        accessor: 'text',
      },
      {
        Header: 'Celkem odpovědí',
        accessor: 'totalAnswers',
      },
      {
        Header: 'Správných odpovědí',
        accessor: 'correctAnswers',
      },
      {
        Header: 'Špatných odpovědí',
        accessor: 'wrongAnswers',
      },
      {
        Header: 'Úspěšnost',
        accessor: 'ratio',
      }
    ];

    const tagTableOptions = {
      ...tableOptions,
      loading: false,
      defaultPageSize: 5
    };

    this.state = {
      tags: [],
      tagWithQuestions: null,
      tagToTable: null,
      columns,
      tableOptions,
      showModal: false,
      loaded: false,
      tagTableColumns,
      tagTableOptions
    };

    this.showTagTable = this.showTagTable.bind(this);
    this.hideTagTable = this.hideTagTable.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.state.loaded) {
      this.getTagsSuccessRate();
      this.setState({
        loaded: true,
      });
    }
  }

  getTagsSuccessRate() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        cache: true,
        withQ: true
      }
    };
    axios.get(this.props.api.stats.questionSuccessRateByTag, config)
      .then((response) => {
        this.setState({
          tags: response.data.map((data) => {
            data.questions = data.questions.map(q => ({
              ...q,
              ratio: Math.round(q.ratio * 100) / 100,
            }));
            data.ratio = Math.round(data.ratio * 100) / 100;
            return data;
          }),
          tableOptions: {
            ...this.state.tableOptions,
            loading: false
          }
        })
      }).catch((error) => {
      console.log("Axios error: ", error);
    });
  }

  showTagTable(tag) {
    this.setState({
      showModal: true,
      tagToTable: tag,
      tagWithQuestions: tag,
    });
  }

  hideTagTable() {
    this.setState({
      showModal: false,
      tagToTable: null,
      tagWithQuestions: null,
      modalLoaded: false
    })
  }

  render() {
    const { tags, tagWithQuestions, showModal, columns, tableOptions, tagTableOptions, tagTableColumns } = this.state;
    const excelData = {
      fileName: 'Úspěšnost otázek podle tagů',
      sheets: [
        {
          name: 'Úspěšnost otázek podle tagů',
          columns: [
            {
              Header: 'Tag',
              accessor: 'name',
            },
            {
              Header: "Celkem odpovědí",
              accessor: 'qtotalAnswers'
            },
            {
              Header: "Správných odpovědí",
              accessor: 'correctAnswers'
            },{
              Header: "Špatných odpovědí",
              accessor: 'wrongAnswers'
            },
            {
              Header: 'Úspěšnost',
              accessor: 'ratio',
            },
          ],
          data: [...tags],
        }
      ],
    };

    const excelElement = (
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-export-tags">Export</Tooltip>}>
        <FontAwesome name="file-excel-o" size="2x" className="cursor-p" />
      </OverlayTrigger>
    );

    return (
      <div className="x-panel">
        <div className="x-title">
          <h2>Úspěšnost otázek podle tagů</h2>
          <div className="clearfix" />
        </div>
        <div className="x-content">
          <div className="export">
            <ExcelExport element={excelElement} data={excelData}/>
          </div>
          <Table
            columns={columns}
            data={tags}
            tableOptions={tableOptions}
            defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
          />
          <Modal show={showModal} onHide={this.hideTagTable} bsSize="large" aria-labelledby="contained-modal-title-lg">
            <Modal.Header closeButton>
              <Modal.Title>Seznam otázek k tagu: {tagWithQuestions ? tagWithQuestions.name : ""}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table
                columns={tagTableColumns}
                data={tagWithQuestions ? tagWithQuestions.questions : []}
                tableOptions={tagTableOptions}
                defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.hideTagTable}>Zavřít</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}


class AnswersGraph extends React.Component {
  render() {
    const { row, ...rest } = this.props;
    const answers = this.props.row.answerLog;
    const chartData = { 'labels': [], 'datasets': [{ data: [], backgroundColor: [] }] };
    const chartOptions = {
      responsive: true,
      title: {
        display: true,
        text: 'Graf úspěšnosti odpovědí'
      },
      legend: {
        display: false
      }
    };
    answers.forEach(
      (answer) => {
        chartData.datasets[0].data.push(answer.answerCount);
        chartData.labels.push(answer.text);
        let color = '#FF0000';
        if (answer.correctness) color = '#00FF00';
        chartData.datasets[0].backgroundColor.push(color);
      }
    );
    return (
      <Popover id={this.props.row.id} {...rest}>
        <div>
          {row.name}
          <Pie data={chartData} options={chartOptions} width={300} height={300} />
        </div>
      </Popover>
    );
  }
}

class GraphForTag extends React.Component {
  render() {
    const { row, ...rest } = this.props;
    const chartData = {
      'labels': ['Úspěšnost', 'Neúspěšnost'],
      'datasets': [{
        data: [
          row.ratio,
          Math.round((100.00 - row.ratio) * 100) / 100
        ],
        backgroundColor: ['#00FF00', '#FF0000']
      }]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: true,
        text: 'Graf úspěšnosti tagu'
      },
      legend: {
        display: false
      }
    };
    return (
      <Popover id={this.props.row.id} {...rest}>
        <div>
          {row.name}
          <Pie data={chartData} options={chartOptions} width={300} height={300} />
        </div>
      </Popover>
    );
  }
}

export default Questions;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/questions.js
 **/